import React from 'react';

import { logout } from '@features/loginSlice';
import { ROUTES } from '@routes/constants';
import { useAppDispatch } from '@store';
import { useNavigate } from 'react-router-dom';

import Logo from '@assets/Logo';

import styles from './style.module.scss';
const Header: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const logoutHandler = () => {
    dispatch(logout());
    navigate(ROUTES.LOGIN);
  };

  return (
    <div className={styles.container}>
      <Logo size={32} />
      <button type="button" className={styles.logout} onClick={() => logoutHandler()}>
        Log out
      </button>
    </div>
  );
};

export default Header;
